import { FC } from 'react'
import { Spinning } from '@zoom/react-ui'
import OneDrivePicker from './OneDrivePicker/OneDrivePicker'
import GoogleFilePicker from './GoogleFilePicker/GoogleFilePicker'
import { useAppSelector, useSelectRunningContext } from '../hooks'
import { App, selectIsGeneralSpinner } from '../app/root'
import TopBar from './TopBar'
import CollaborationBanner from './CollaborationBanner'

type PickersProps = {
  app: App
}

const Pickers: FC<PickersProps> = ({ app }) => {
  const isGeneralSpinner = useAppSelector(selectIsGeneralSpinner)
  const runningContext = useSelectRunningContext()

  return (
    <>
      {app === 'Microsoft' ? (
        <Spinning
          spinning={isGeneralSpinner}
          size='large'
          label=''
        >
          <TopBar />
          {runningContext === `inCollaborate` && <CollaborationBanner />}
          <OneDrivePicker />
        </Spinning>
      ) : (
        <>
          {/* Since the Google picker is outside of the main app dom, we have to do special styles to place the spinner over it */}
          {isGeneralSpinner && (
            <Spinning
              spinning={isGeneralSpinner}
              size='large'
              sx={{
                height: '100vh !important',
                position: 'absolute !important',
                width: '100% !important',
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                'z-index': '10000',
                '.ui-Spinning-spikes': {
                  top: '50% !important',
                },
              }}
            />
          )}
          <TopBar />
          {runningContext === `inCollaborate` && <CollaborationBanner />}
          <GoogleFilePicker />
        </>
      )}
    </>
  )
}

export default Pickers
